import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateManzanitaPresetForm } from "../forms/create/CreateManzanitaPresetForm";

export type AddManzanitaPresetButtonProps = ButtonProps;

export const AddManzanitaPresetButton: FunctionComponent<AddManzanitaPresetButtonProps> = (
    props: AddManzanitaPresetButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Add preset"} onDismiss={closeAside}>
                <CreateManzanitaPresetForm onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
